<template>
    <div class="layers-container">
        <!-- ---------------- LEFT COLUMN ------------- -->
        <div style="width: 300px; padding: 10px;">
            <!-- SELECTED PARAM -->
            <div class="selected-param-container">
                <div v-if="hover_param" class="selected-param-circle" v-bind:class="'circle' + hover_param"></div>
                <div v-else class="selected-param-circle" v-bind:class="'circle' + selected_param"></div>
                <div class="selected-param-text"> 
                    {{selected_param_text}}
                </div>
            </div>
            <div class="button-layer-main-container">    
                <div @click="change_selected_param(1, false, true)" class="button-param" v-bind:class="{ 'button-param-selected': selected_param==1 }" @mouseover="change_selected_param(1, true, false)" @mouseleave="change_selected_param(selected_param,false,false)">
                    <div class="param param1" v-bind:class="{ 'param-selected': selected_param==1 }"></div>
                </div>
                <div @click="change_selected_param(2, false , true)" class="button-param" v-bind:class="{ 'button-param-selected': selected_param==2 }" @mouseover="change_selected_param(2, true, false)" @mouseleave="change_selected_param(selected_param,false,false)">
                    <div class="param param2" v-bind:class="{ 'param-selected': selected_param==2 }"></div>
                </div>
                <div @click="change_selected_param(3, false, true)" class="button-param" v-bind:class="{ 'button-param-selected': selected_param==3 }" @mouseover="change_selected_param(3, true, false)" @mouseleave="change_selected_param(selected_param,false,false)">
                    <div class="param param3" v-bind:class="{ 'param-selected': selected_param==3 }"></div>
                </div>
                <div @click="change_selected_param(4, false, true)" class="button-param" v-bind:class="{ 'button-param-selected': selected_param==4 }" @mouseover="change_selected_param(4, true, false)" @mouseleave="change_selected_param(selected_param,false,false)">
                    <div class="param param4" v-bind:class="{ 'param-selected': selected_param==4 }"></div>
                </div>
            </div>
         
            <!-- STATIONS OR DENSITY MAPS -->
            <div class="button-layer-main-container">
                <div @click="change_stations_or_density('stations')" class="button-layer-main" v-bind:class="{ 'button-layer-main-selected': stations_or_density[0]=='stations' }">
                    <div class="button-light" v-bind:class="{ 'button-light-on': stations_or_density[0]=='stations' }"></div>
                    Estaciones
                </div>
                <div @click="change_stations_or_density('density')" class="button-layer-main" v-bind:class="{ 'button-layer-main-selected': stations_or_density[1]=='density' }">
                    <div class="button-light" v-bind:class="{ 'button-light-on': stations_or_density[1]=='density' }"></div>
                    Heatmaps 
                </div>
            </div>
            <div class="button-layer-main-container">
                <div @click="change_stations_or_density('transect')" class="button-layer-main" v-bind:class="{ 'button-layer-main-selected': stations_or_density[2]=='transect' }" >
                    <div class="button-light" v-bind:class="{ 'button-light-on': stations_or_density[2]=='transect' }"></div>
                    Corte
                </div>
                <div @click="change_stations_or_density('serie_temp')" class="button-layer-main" v-bind:class="{ 'button-layer-main-selected': stations_or_density[3]=='serie_temp' }" >
                    <div class="button-light" v-bind:class="{ 'button-light-on': stations_or_density[3]=='serie_temp' }"></div>
                    Evolución
                </div>
                    <!-- <button type="button" class="btn btn-primary" id="transects" @click="change_stations_or_density('transect')">Transectos</button> -->
            </div>
        </div>

        <!-- ---------------- RIGHT COLUMN ------------- -->
        <!-- DEPTH SELECTOR -->
        <div class="depth-container">
            <div class="depth-text"> {{available_depths [1]}} </div>
            <div class="depth-bar-container">
                <div class="slider-line"></div>
                <input class="slider" type="range" orient="vertical" min="0" :max ="available_depths.length - 1" step="1" v-model="selected_depth" />
            </div>
            <div class="depth-text"> {{available_depths [0]}} </div>
        </div>
    </div>
</template>

<script>
  // Vuex
  import { mapGetters } from 'vuex'
  import removeTransects from '@/components/MapParams.vue'
  

  export default {
    name: 'panelLayers',
    data: function () {
        return {
            selected_param_text: '',
            hover_param: null,
        }
    },
    computed: {
        ...mapGetters(
            "map_params",{
                available_depths: 'available_depths',
                transect_points: 'transect_points',
            }      
        ),
        stations_or_density: {
            set (stat_or_den) { this.$store.dispatch('map_params/change_stations_or_density', stat_or_den); },
            get () { return this.$store.state.map_params.stations_or_density }
        },
        selected_param: {
            set (param) { this.$store.dispatch('map_params/change_selected_param', param); },
            get () { return this.$store.state.map_params.selected_param }
        },
        selected_depth: {
            set (depth) { this.$store.dispatch('map_params/change_selected_depth', parseInt(depth)); },
            get () { return this.$store.state.map_params.selected_depth}
        },
        transect_status: {
            set (status) { this.$store.dispatch('map_params/change_transect_status', status); },
            get () { return this.$store.state.map_params.transect_status }
        },
        serie_status: {
            set (status) { this.$store.dispatch('map_params/change_serie_status', status); },
            get () { return this.$store.state.map_params.serie_status }
        },
    },

    componets:{
        removeTransects
    },

    mounted () {
        this.change_selected_param(this.selected_param, false)
        // Por alguna razón la línea de abajo permite que los mapas de calor y los transectos no desaparezcan cuando nos vamos a otra pestaña.
        // Aunque ahora los mapas de calor y los transectos se resetean cuando cambiamos de pestaña. Esto lo hace el watch $route (88-99) del componente header.
        this.stations_or_density = ['stations','','','']
    },
    methods: {
        change_stations_or_density(st_or_den) {
            this.stations_or_density = st_or_den
            if(st_or_den == 'transect') {
                if(this.stations_or_density[2] != 'transect') {
                    this.$store.dispatch("map_params/reset_results_transect_1")
                }
                if(this.stations_or_density[3] != 'serie_temp') {
                    this.$store.dispatch("map_params/reset_results_serie_temp")
                }
            }
        },
        change_selected_param(param, isHover, isClick) {
            if(!isHover) {             
                this.hover_param = null
                if(this.transect_status == 0 || this.transect_status == 4) {
                    this.selected_param = param
                }
                if(this.serie_status == 0 || this.serie_status == 4) {
                    this.selected_param = param
                }

                if(isClick){
                    if(this.stations_or_density[2] == 'transect' && this.transect_status == 4){
                        this.transect_status = 3
                        this.$store.dispatch('map_params/change_transect_points', this.transect_points)
                    }
                    // diferenciar entre serie de todo el mar menor y un transecto
                    if(this.stations_or_density[3] == 'serie_temp' && this.serie_status == 4){
                        this.serie_status = 3
                        if (this.transect_points.length > 0){
                            this.$store.dispatch('map_params/change_serie_transect_points', this.transect_points)
                        }else{
                            this.$store.dispatch('map_params/change_serie_temporal_MM', '')
                        }
                    }
                }             
            }
            else {
                this.hover_param = param
            }     
            switch (param) {
                case 1:
                    this.selected_param_text = 'Concentración de oxígeno disuelto'
                    break
                case 2:
                    this.selected_param_text = 'Porcentaje de oxígeno disuelto'
                    break
                case 3:
                    this.selected_param_text = 'Clorofila'
                    break
                case 4:
                    this.selected_param_text = 'Salinidad'
                    break
            }          
        }
    }
  }
</script>

<style scoped>
    .layers-container {
        display: flex;
        flex-direction: row;
    }
    .button-layer-main-container {
        display: flex; 
        flex-direction: row; 
        justify-content: space-around;
        margin-top: 12px;
        margin-bottom: 16px;
    }

    /* PARAMS BUTTONS */
    .selected-param-container {
        display: flex; 
        flex-direction: row; 
        padding: 0px 8px 0px 8px;
        align-items: center;
    }
    .selected-param-text {
        color: #447998;
        font-size: 0.8rem;
        margin-right: 12px;
    }
    .selected-param-circle {
        margin-right: 12px;
        border-radius: 50px;
        width: 10px;
        height: 10px;
        background-color: #C6DDE277;
    }
    .circle1 {
        background-color: #03B2FF;
    }
    .circle2 {
        background-color: #0079A3;
    }
    .circle3 {
        background-color: #1ED3C6;
    }
    .circle4 {
        background-color: #F48F16;
    }
    .button-param {
        padding: 2px;
        border-radius: 4px;
        width: 22%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #C6DDE2FF;
        font-size: 0.9rem;
        cursor: pointer;
        /* box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.3); */
        /* background: linear-gradient(180deg, #f4fafeFF 0%, #f4fafeFF 80%); */
        /* background: linear-gradient(180deg, #C6DDE277 0%, #ffffff 30%); */
        box-shadow: 4px 4px 5px #C6DDE2, 
            -5px -5px 6px #ffffff;
    }
    .button-param:hover {
        background-color: #1ED3C6;
    }
    .button-param-selected {
        box-shadow: 1px 1px 3px #C6DDE2, 
            -5px -5px 6px #ffffff;
    }

    .button-transectos{
        display: flex;
        flex-direction: row;
        margin-left: 32%;
    }

    .param {
        border-radius: 4px;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-size: auto 75%;
        background-position: center;
        background-repeat: no-repeat;
        min-height: 40px;
        opacity: 0.2;
    }
    .param-selected {
        opacity: 1;
    }
    .param:hover{
        opacity: 1;
    }
    .param1 {
        background-color: #03B2FF;
        background-image: url('~@/assets/img/params/icon_con_ox.svg');  
    }
    .param2 {
        background-color: #0079A3;
        background-image: url('~@/assets/img/params/icon_por_ox.svg');    
    }
    .param3 {
        background-color: #1ED3C6;
        background-image: url('~@/assets/img/params/icon_clorofila.svg');  
    }
    .param4 {
        background-color: #F48F16;
        background-image: url('~@/assets/img/params/icon_salinidad.svg');    
    }

    /* STATIONS OR DENSITY BUTTONS */   
    .button-layer-main {
        /* background-color: #f4fafe; */
        padding: 12px;
        border-radius: 50px;
        width: 45%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #C6DDE2FF;
        font-size: 0.9rem;
        cursor: pointer;
        /* box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.3); */
        /* background: linear-gradient(180deg, #f4fafeFF 0%, #f4fafeFF 80%); */
        /* background: linear-gradient(180deg, #C6DDE277 0%, #ffffff 30%); */
        box-shadow: 4px 4px 5px #C6DDE2, 
            -5px -5px 6px #ffffff;
    }
    .button-layer-main-selected {
        color: #447998;
        box-shadow: 1px 1px 3px #C6DDE2, 
            -5px -5px 6px #ffffff;
    }
    .button-light {
        margin-right: 12px;
        border-radius: 50px;
        width: 7px;
        height: 7px;
        background-color: #C6DDE277;
    }
    .button-light-on {
        border-radius: 50px;
        background-color:#1CBBB4;
        /* box-shadow: 0px 0px 5px #1CBBB4 */
    }
    .button-layer-main:hover {
        color:#1CBBB4;
    }

    /* DEPTH SELECTOR */
    .depth-container {
        width: 100px;
        border-left: 2px solid #C6DDE2;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: auto;
    }
    .depth-bar-container {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    input[type=range][orient=vertical] {
        writing-mode: bt-lr; /* IE */
        -webkit-appearance: slider-vertical; /* WebKit */
        height: 80px;
        width: 4px;
        padding: 0 5px;
    }
    .depth-text {
        padding: 12px;
        color: #447998;
        font-size: 0.8rem;
    }

    .slider {
        -webkit-appearance: none;
        width: 4px;
        z-index: 10;
        /* width: 100%;
        height: 25px; */
        /* background: #F4FAFE; */
        background: #44799800;
        outline: none;
        /* opacity: 1;
        -webkit-transition: .2s;
        transition: opacity .2s; */
    }

    /* .slider:hover {
        opacity: 1;
    } */

    .slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 19px;
        height: 19px;
        background: #FFFFFF;
        cursor: pointer;
        border: none;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3);
    }

    .slider::-moz-range-thumb {
        width: 19px;
        height: 19px;
        background: #FFFFFF;
        cursor: pointer;
        border: none;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3);
    }
    .slider-line {
        width: 4px;
        background-color: #447998AA;
        height: 80px;
        position: absolute;
    }



    /* **********   ANIMATIONS   ************ */
    .button-layer-main,.button-light,.button-param,.param {
        -webkit-transition: .25s ease-in-out;
        -moz-transition: .25s ease-in-out;
        -o-transition: .25s ease-in-out;
        transition: .25s ease-in-out;
    }


</style>



// WEBPACK FOOTER //
// src/components/mapparams/panelLayers.vue